<template>
    <div class="basic">
        <div class="manage-title"><em class="txt">基本信息</em></div>
        <div class="infoBox margin-top-20">
            <div class="item flex">
                <p class="tit">企业名称</p>
                <p class="txt">{{name}}</p>
            </div>
            <div class="item flex">
                <p class="tit">所属行业</p>
                <p class="txt">{{industry}}</p>
            </div>
            <div class="item flex">
                <p class="tit">企业电话</p>
                <p class="txt">{{phone}}</p>
            </div>
            <div class="item flex">
                <p class="tit">企业地址</p>
                <p class="txt">{{address}}</p>
            </div>
            <div class="item flex">
                <p class="tit">企业简介</p>
                <p class="txt">{{content}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'InfoBasic',
    props: {
        name: String,
        industry: String,
        phone: String,
        address: String,
        content:String
    }
}
</script>
<style scoped></style>
